import PrivateRoute from "PrivateRoutes";
import React from "react";
import { withRouter } from "react-router";
import OrganisationSetting from "./index";
import FlowTemplate from "./FlowTemplate/components/FlowTemplate";
import TTSProvider from "./TTSProvider/components/TTSProvider";
import TTSModel from "./TTSModel/components/TTSModel";
import STTProvider from "./STTProvider/components/STTProvider";
import STTModel from "./STTModel/components/STTModel";
import LLMProvider from "./LLMProvider/components/LLMProvider";
import LLMModel from "./LLMModel/components/LLMModel";

const routes = () => [
  <PrivateRoute
    key="organization-settings"
    exact
    path="/organization-settings"
    component={OrganisationSetting}
  />,
  <PrivateRoute
    key="organization-settings/flow-template"
    exact
    path="/organization-settings/flow-template"
    component={FlowTemplate}
  />,
  <PrivateRoute
    key="organization-settings/tts-provider"
    exact
    path="/organization-settings/tts-provider"
    component={TTSProvider}
  />,
  <PrivateRoute
    key="organization-settings/tts-model"
    exact
    path="/organization-settings/tts-model"
    component={TTSModel}
  />,
  <PrivateRoute
    key="organization-settings/stt-provider"
    exact
    path="/organization-settings/stt-provider"
    component={STTProvider}
  />,
  <PrivateRoute
    key="organization-settings/stt-model"
    exact
    path="/organization-settings/stt-model"
    component={STTModel}
  />,
  <PrivateRoute
    key="organization-settings/llm-provider"
    exact
    path="/organization-settings/llm-provider"
    component={LLMProvider}
  />,
  <PrivateRoute
    key="organization-settings/llm-model"
    exact
    path="/organization-settings/llm-model"
    component={LLMModel}
  />,
];

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/Org_setting/routes.js